<template>
  <div v-if="show_body">
  	<public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

		<div class="container text-center">
			<div class="top greyline">
				<img :src="headimgurl" class="head">
				<h1 class="headtitle">{{headtitle}}</h1>
			</div>
			<div class="main">
				<p>以下得分表示了您的职业倾向性程度：</p>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>R</th>
							<th>I</th>
							<th>A</th>
							<th>S</th>
							<th>E</th>
							<th>C</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>您所感兴趣的活动（兴趣）</td>
							<td>{{result.R1}}</td>
							<td>{{result.I1}}</td>
							<td>{{result.A1}}</td>
							<td>{{result.S1}}</td>
							<td>{{result.E1}}</td>
							<td>{{result.C1}}</td>
						</tr>
						<tr>
							<td>您所擅长的活动（能力）</td>
							<td>{{result.R2}}</td>
							<td>{{result.I2}}</td>
							<td>{{result.A2}}</td>
							<td>{{result.S2}}</td>
							<td>{{result.E2}}</td>
							<td>{{result.C2}}</td>
						</tr>
						<tr>
							<td>您所喜欢的职业（回馈）</td>
							<td>{{result.R3}}</td>
							<td>{{result.I3}}</td>
							<td>{{result.A3}}</td>
							<td>{{result.S3}}</td>
							<td>{{result.E3}}</td>
							<td>{{result.C3}}</td>
						</tr>
					</tbody>
					<tfoot>
						<tr>
							<th>总分</th>
							<th>{{result.R}}</th>
							<th>{{result.I}}</th>
							<th>{{result.A}}</th>
							<th>{{result.S}}</th>
							<th>{{result.E}}</th>
							<th>{{result.C}}</th>
						</tr>
					</tfoot>
				</table>
				<router-link class="btn-bottom" to="/ceping51?reset=1">重新测试</router-link>
			</div>
		</div>
		<!-- 微信 -->
		<van-popup class="radius" :close-on-click-overlay="false" v-model="kc_show">
      <div class="pop">
        <img class="qr-box" src="@a/coach_ceping47.jpg" alt="" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ceping51_report } from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
	data(){
		return {
			show_body: false,
			kc_show: false,
			//
			cid: 51,
			nickname: '',
			headimgurl: '',
			headtitle: '' + '报告',
			result: {},
			data: {},
		}
	},
  components:{
    PublicAdQrcode,
    PublicTopTips,
  },
	methods: {
		pullData(){
			this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
			ceping51_report()
			.then((data) => {
				this.$toast.clear();
				if(!data.code){
					this.data = data;

					document.title = data.headtitle;

					this.nickname = data.nickname;
					this.headimgurl = data.headimgurl;
					this.headtitle = data.headtitle + '报告';
					this.result = data.result;
					this.show_body = true;

					// 神策统计--打开页面时触发
          sensors.track('evaluationPage', {
            evaluation_id: String(data.cid),
            evaluation_name: data.headtitle,
            evaluation_url: window.location.href,
            evaluation_page_title: data.headtitle,
            share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
            channel_name: this.$route.query.channel ? this.$route.query.channel : ""
          })
				}else{
					this.$router.push({
						path: '/ceping51'
					})
				}
			})
		}
	},
  created() {
    this.pullData();
    // shareCon("measurement",this);
  }
}
</script>
<style lang="scss" scoped>
	@import "@s/remChange.scss";
	.container {
		padding: changeRem(0.75)+px;
	}
	.top {
		text-align: left;
		position: relative;
		padding-bottom: changeRem(0.7)+px;
	}
	.greyline {
		border-bottom: 2px dashed #333;
	}
	.head {
		position: absolute;
		top: 0;
		left: 0;
		width: changeRem(2.5)+px;
		height: changeRem(2.5)+px;
		border-radius: 50%;
		vertical-align: bottom;
	}
	.headtitle {
		padding-left: changeRem(2.5)+px;
		text-indent: changeRem(0.5)+px;
		line-height: changeRem(2.5)+px;
		font-size: changeRem(0.75)+px;
		color: #00A0F6;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.blueline {
		border-bottom: 2px solid #fff;
	}
	.main {
		text-align: left;
		padding: changeRem(0.75)+px 0;
	}
	.main img {
		max-width: 100%;
	}
	.main ul, .main li {
		list-style: disc inside;
	}
	.main p, .main ul li {
		text-align: left;
		color: #333;
		font-size: changeRem(0.6)+px;
		line-height: changeRem(1)+px;
		padding-bottom: changeRem(0.3)+px;
	}
	.blue {
		color: #00A0F6;
	}
	.subtitle {
		color: #00A0F6;
		font-size: changeRem(0.75)+px;
		padding-bottom: changeRem(0.75)+px;
	}

	.btn-bottom {
		font-size: changeRem(0.65)+px;
		text-align: center;
		color: #fff;
		position: fixed;
		bottom: 0;
		left: 0;
		height: changeRem(2)+px;
		width: 100%;
		background: #eb5032;
		line-height: changeRem(2)+px;
	}
	.main table, .main table tr, .main table td, .main table th {
		width: 100%;
		border: 2px solid #333;
		color: #333;
		font-size: changeRem(0.6)+px;
		text-align: center;
		min-width: changeRem(1)+px;
	}
	table {
    border-spacing: 0;
    border-collapse: collapse;
	}
	.radius{
		border-radius: 10px;
		.pop{
			width: 9rem;
			img{
				max-width: 100%;
			}
		}
	}
</style>